import { call, delay, put, select, takeEvery, takeLatest } from "redux-saga/effects"

import { server_url } from '../core/config_geral'
import axios from 'axios';
import { cleanForm, defineErroStorage, defineStorageBuckets, defineUploading, setArquivos, setModalOpen, setSelectedBucket, triggerCarregaBuckets, triggerEnviaForm, triggerRemoveFile, triggerSelectBucket } from "./StorageSlice";
import { generalErrorAction, publicarError } from "../helper/general-error/GeneralErrorSlice";
import { isNotNull } from "../helper/functions";

function* doListenEnviaForm() {
    var form = yield select((state) => state.storage.form)
    var token = yield select((state) => state.auth.token)

    if(form.bucket.trim().length == 0) {
        yield put(defineErroStorage("Bucket não definido"))
    } else if(form.remetente.trim().length == 0) {
        yield put(defineErroStorage("Remetente não definido"))
    } else if(form.file == null) {
        yield put(defineErroStorage("Arquivo não definido"))
    } else {    


        var arquivos = yield select((state) => state.storage.arquivos)
        
        var arqEncontrado = arquivos.filter(e => e.nome == form.file.name && e.bucket == form.bucket && e.path == form.path)
        
        if(arqEncontrado.length == 1) arqEncontrado = arqEncontrado[0] 
        else arqEncontrado = false
        
        // console.log(form)
        // console.log(arquivos)
        // console.log(arqEncontrado)
        // return

        var payload = {
            remetente : form.remetente,
            nome : form.file.name,
            bucket : form.bucket,
            path : form.path,
            encryptKey : form.encryptKey,
            version : arqEncontrado != false ? arqEncontrado.version : 0
        }
    
        var formData = new FormData()
        formData.append("file", form.file)
        formData.append("data", 
            new Blob([JSON.stringify(payload)], {
                type : "application/json"
            })) 

        yield put(defineUploading(true))

        var r = yield call(() => axios.post(server_url + "/storage", formData, {
            headers : {
                'Content-Type' : 'multipart/form-data',
                'Authorization' : 'Bearer ' + token
            }
        }).then(response => response)
        .catch(error => error))

        yield put(defineUploading(false))

        if(r.status && r.status == 200) {
            yield put(cleanForm())
            yield put(setModalOpen(false))
            yield put(triggerCarregaBuckets())
            yield put(triggerSelectBucket(form.bucket))
        } else {
            yield put(publicarError(generalErrorAction(
                "StorageSaga.doListenEnviaForm",
                isNotNull(r.code) ? r.code : "",
                isNotNull(r.response) ? r.response.status: "",
                isNotNull(r.message) ? r.message : "",
                r
            )))
        }
    }

}

function* doListenCarregaBuckets() {
    var token = yield select((state) => state.auth.token)
    var r = yield call(() => axios.get(server_url + "/storage/buckets",
    {
        headers : {
            'Authorization' : 'Bearer ' + token
        }
    }).catch(error => error))

    if(typeof(r.code) != "undefined" && r.code != 200) {
        yield put(publicarError(generalErrorAction(
            "StorageSaga.doListenCarregaBuckets",
            isNotNull(r.code) ? r.code : "",
            isNotNull(r.response) ? r.response.status: "",
            isNotNull(r.message) ? r.message : "",
            r
        )))
        return
    } 

    yield put(defineStorageBuckets(r.data))
}

function* doListenSelectBucket({payload}) {
    yield put(setSelectedBucket(payload))
    yield put(setArquivos([]))
    var token = yield select((state) => state.auth.token)
    

    var r = yield call(() => axios.get(server_url + "/storage/buckets/"+payload+"/arquivos",
    {
        headers : {
            'Authorization' : 'Bearer ' + token
        }
    }).catch(error => error))

    if(typeof(r.code) != "undefined" && r.code != 200) {
        yield put(publicarError(generalErrorAction(
            "StorageSaga.doListenCarregaBuckets",
            isNotNull(r.code) ? r.code : "",
            isNotNull(r.response) ? r.response.status: "",
            isNotNull(r.message) ? r.message : "",
            r
        )))
        return
    } 

    yield put(setArquivos(r.data))
}


function* doRemoveFile(action) {

    yield put(setArquivos([]))
    var token = yield select((state) => state.auth.token)

    var r = yield call(() => axios.delete(server_url + "/storage/buckets/"+action.payload.bucket+"/arquivos/"+action.payload.id,
    {
        headers : {
            'Authorization' : 'Bearer ' + token
        }
    }).catch(error => error))

    if(typeof(r.code) != "undefined" && r.code != 200) {
        yield put(publicarError(generalErrorAction(
            "StorageSaga.doRemoveFile",
            isNotNull(r.code) ? r.code : "",
            isNotNull(r.response) ? r.response.status: "",
            isNotNull(r.message) ? r.message : "",
            r
        )))
        return
    } 

    yield put(triggerSelectBucket(action.payload.bucket))

}

export function* listenEnviaForm() {
    yield takeLatest(triggerEnviaForm, doListenEnviaForm)
}

export function* listenCarregaBuckets() {
    yield takeLatest(triggerCarregaBuckets, doListenCarregaBuckets )
}

export function* listenSelectBucket() {
    yield takeLatest(triggerSelectBucket, doListenSelectBucket)
}

export function* listenRemoveFile() {
    yield takeEvery(triggerRemoveFile, doRemoveFile)
}
// export function* listenLogar() {
//     yield takeEvery(triggerLogar, doLogar);
// }
